export const googleModels = [
  'GEMINI-gemini-3.0-pro',
  'GEMINI-gemini-3.0-flash',
  'GEMINI-gemini-2.5-pro',
  'GEMINI-gemini-2.5-flash',
  'GEMINI-gemini-2.0-flash',
  'GEMINI-gemini-2.0-flash-lite',
  'GEMINI-gemini-1.5-pro-latest',
  'GEMINI-gemini-1.5-flash',
];

export const mistralModels = [
  'MISTRAL-mistral-small-latest',
  'MISTRAL-mistral-medium-latest',
  'MISTRAL-mistral-large-latest',
  'MISTRAL-pixtral-large-latest',
  'MISTRAL-codestral-latest',
];

export const allModelOptions = [...googleModels, ...mistralModels];

export const getDropdownSx = () => {
  const longestOption = allModelOptions.reduce((a, b) => (a.length > b.length ? a : b), '');
  const dropdownChars = Math.min(longestOption.length + 2, 25);
  return { width: `${dropdownChars}ch` };
};

export const formatModelDisplayName = (modelName: string) => {
  return modelName.replace(/(GEMINI-)|(MISTRAL-)/g, '');
};
